<template>
  <v-dialog v-model="open" width="500" persistent>
    <v-card v-if="open">
      <v-card-title class="headline">
        <div class="break-word">{{$t('shifts.open_shift.title', { operator: operatorName, printer: printerName })}}</div>
      </v-card-title>
      <v-card-text class="text-center">
        <v-form class="pa-2" ref="form" v-if="paymentMethods.length && currencies.length">
          <v-layout row wrap v-for="(paymentMethod, i) in paymentMethods" :key="i">
            <v-flex xs12 class="caption">{{paymentMethod.name}}</v-flex>
            <v-flex xs12 sm6 v-for="currency in currencies" :key="currency.id" class="pa-1">
              <v-text-field
                hide-details
                outlined
                class="price"
                :value="displayValues[`${paymentMethod.id}.${currency.id}`]"
                @input="(amount) => setAmount({ paymentMethodId: paymentMethod.id, currencyId: currency.id, amount })"
              >
                <template slot="append">{{currency.name}}</template>
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
        <v-progress-circular v-else indeterminate color="secondary" />
      </v-card-text>
      <v-card-actions>
        <v-layout column>
          <v-layout row justify-end class="ma-0">
            <v-btn text color="primary" @click="open = false" class="mt-3">{{$t('actions.cancel')}}</v-btn>
            <v-btn :loading="state.loading" outlined color="primary" @click="openShift()" class="mt-3">{{$t('shifts.actions.open')}}</v-btn>
          </v-layout>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moneyFormatMixins from '@/mixins/MoneyFormat'
import { mapGetters, mapState } from 'vuex'
export default {
  props: {
    triggerOpen: Date,
    inNavigationMenu: Boolean
  },
  data () {
    return {
      open: false,
      printerPeripheral: null,
      displayValues: {}
    }
  },
  mixins: [
    moneyFormatMixins
  ],
  computed: {
    ...mapState({
      state: state => state.state,
      shifts: state => state.shifts
    }),
    ...mapGetters({
      currencies: 'configuration/currencies',
      paymentMethodIds: 'configuration/paymentMethodIds'
    }),
    paymentMethods () {
      return this.paymentMethodIds && this.$store.state.paymentMethods.list.length ? this.paymentMethodIds.map((id) => {
        return this.$store.state.paymentMethods.list.find((pM) => {
          return pM.id === id
        })
      }) : []
    },
    operatorName () {
      return this.$store.state.auth.credentials ? this.$store.state.auth.credentials.operator.name : '-'
    },
    printerName () {
      return this.printerPeripheral ? (this.printerPeripheral.label || this.printerPeripheral.model || this.printerPeripheral.id) : '-'
    }
  },
  methods: {
    openShift () {
      this.$store.dispatch('shifts/open').then(() => {
        this.open = false
        this.$store.commit('state/setMessage', { text: this.$t('shifts.open_shift.success'), color: 'success' })
      }).catch((error) => {
        const { message } = error.body
        if (message === '{error=NO_OPEN_SHIFT}') {
          if (!this.isSupervisor) {
            this.$store.commit('state/setMessage', { text: this.$t('error.no_open_shift_supervisor'), color: 'error' })
          }
        } else if (message && message.includes('PRINTER_HAS_OPEN_SHIFT')) {
          this.$store.commit('state/setMessage', { text: this.$t('shifts.open_shift.error.PRINTER_HAS_OPEN_SHIFT'), color: 'error' })
        } else {
          this.$store.commit('state/setMessage', { text: this.$t('shifts.open_shift.error.fallback'), color: 'error' })
        }
      })
    },
    setAmount ({ amount, paymentMethodId, currencyId }) {
      this.$set(this.displayValues, `${paymentMethodId}.${currencyId}`, null)
      if (typeof amount !== 'undefined' && amount !== '') {
        this.$store.commit('shifts/setAccountingState', {
          currencyId,
          paymentMethodId,
          amount: this.parsePrice(amount)
        })
        this.$nextTick(() => {
          this.$set(this.displayValues, `${paymentMethodId}.${currencyId}`, this.sanitizePrice(amount, this))
        })
      } else {
        this.$store.commit('shifts/setAccountingState', { currencyId, paymentMethodId, amount: null })
        this.$nextTick(() => {
          this.$set(this.displayValues, `${paymentMethodId}.${currencyId}`, null)
        })
      }
    }
  },
  watch: {
    triggerOpen () {
      this.open = true
      this.$store.dispatch('peripherals/get', { id: localStorage.getItem('selectedPrinter') }).then((peripheral) => {
        this.printerPeripheral = peripheral
      })
      this.$store.dispatch('paymentMethods/list')
    },
    open () {
      if (!this.open) {
        this.displayValues = {}
      }
      this.$store.dispatch('shifts/resetAccountingState')
    },
    currencies () {
      this.$store.dispatch('shifts/resetAccountingState')
    }
  }
}
</script>

<style lang="scss">
.v-text-field .v-input__append-inner, .v-text-field .v-input__prepend-inner {
  margin-top: auto;
  margin-bottom: auto;
  min-width: fit-content;
}
.v-input.price input {
  text-align: right;
}
</style>